<template>
    <div>
        <v-container fluid class="pa-0 mt-3">
            <v-row>
                <v-col class="py-0">
                    <v-card variant="flat" tile color="#26473a">
                        <v-carousel height="220" :show-arrows="false" hide-delimiter-background hide-delimiters>
                            <v-carousel-item tile min-width="1162" aspect-ratio="0.0192307"
                                src="https://dellpartnerincentives.com/siteassets/Banners/green_aboutrise.jpg"
                                alt=""
                                height="100%" width="100%">
                                <div class="general-carousel-heading">
                                    <LanguagePlaceholder is-html default-text="About RISE" />
                                </div>
                                <div class="carousel-banner banner-line" style="background-color: #349e5f;"></div>
                            </v-carousel-item>
                        </v-carousel>
                    </v-card>

                </v-col>
            </v-row>
            <v-row no-gutters="" justify="center" style="background-color: #e5ffd8;">

                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-container>
                        <p class="general-heading" style="color: #244739;">
                            <h1 style="color: #000c30; font-weight: 300;" class="text-h4"><LanguagePlaceholder is-html
                                default-text="<strong>Incentive Period</strong>: 3 May 2025 – 1 August 2025" /></h1>
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="When partners join the RISE Incentive program, they earn dollar (USD) rewards every time they purchase an eligible product from Dell Technologies through Authorized Distribution partners. " />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="On top of their core rewards, partners can also benefit from a rewards multiplier of up to 1.6x when they hit their unit sales thresholds. The multiplier will apply right back to the very first unit they’ve purchased in each incentive period, so it can make a big difference to their total reward earnings. Partners will also have many opportunities to earn bonus payments. You can see which bonuses your partners are eligible for on the Bonus Report page. " />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="RISE rewards accumulate over each Dell 13-week incentive period. At the end of each incentive period, partner rewards are paid in the form of distributor e-vouchers or credit notes, depending on their total RISE earnings*." />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="If a partner earns $850 (USD) or more in the incentive period, you will receive a credit note to apply to their account. Please note that they may reach this $850 (USD) value by purchasing through multiple distributors, so the credit note you receive may be for a lower total value. " />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="If a partner earns less than $850 (USD), they will be able to exchange their RISE rewards for distributor e-vouchers. " />
                        </p>
                        <br>
                        <p>
                            <span class='font-italic'>
                                <LanguagePlaceholder
                                    default-text="* Except locations where local legislation prevents the use of e-vouchers" />
                            </span>
                        </p>
                    </v-container>
                </v-col>
                <v-col cols="0" sm="2"></v-col>

            </v-row>
            <v-row no-gutters justify="center" style="background-color: #ffffff;">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-container>
                        <p class="general-heading">
                            <LanguagePlaceholder default-text="How Partners can Multiply their Rewards" />

                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="When partners achieve their unit thresholds for PCs+Displays+Peripherals, Server+ or Storage+, they can multiply their rewards by up to 1.6x." />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="Each threshold is independent. A partner can achieve their PC+ threshold, and be paid up to 1.6x their PC+ rewards, without the need to achieve their Server+ or Storage+ thresholds." />
                        </p>
                        <br>
                        <p style="font-weight: 600;">
                            <LanguagePlaceholder default-text="PCS + DISPLAYS + PERIPHERALS" />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder
                                default-text="PCs, Displays and Client Peripheral units bought as SnS" />
                        </p>
                        <v-container>
                            <v-row no-gutters class="my-2">
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="0 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="30 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="80 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="250 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="400 Units" />
                                </v-col>
                            </v-row>
                            <v-row no-gutters
                                style="height: 50px; background-color: #9fff99; font-size: 20px; font-weight: 500;">
                                <v-col class="text-center text-black align-self-center">
                                    <LanguagePlaceholder default-text="1x Rewards" />
                                </v-col>
                                <v-col class="text-center text-black align-self-center">
                                    <LanguagePlaceholder default-text="1.2x" />
                                </v-col>
                                <v-col class="text-center text-black align-self-center">
                                    <LanguagePlaceholder default-text="1.3x" />
                                </v-col>
                                <v-col class="text-center text-black align-self-center">
                                    <LanguagePlaceholder default-text="1.5x" />
                                </v-col>
                                <v-col class="text-center text-black align-self-center">
                                    <LanguagePlaceholder default-text="1.6x" />
                                </v-col>
                            </v-row>
                        </v-container>
                        <br>
                        <p style="font-weight: 600;">
                            <LanguagePlaceholder default-text="Or" />
                        </p>
                        <br>
                        <p style="font-weight: 600;">
                            <LanguagePlaceholder default-text="SERVER+" />
                        </p>
                        <p>
                            <LanguagePlaceholder
                                default-text="Server units bought as SnS or B2B Smart Selection Offers" />
                        </p>
                        <v-container>
                            <v-row no-gutters class="my-2">
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="0 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="5 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="10 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="15 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="20 Units" />
                                </v-col>
                            </v-row>
                            <v-row no-gutters
                                style="height: 50px; background-color: #266440; font-size: 20px; font-weight: 500; ">
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1x Rewards" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.2x" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.3x" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.5x" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.6x" />
                                </v-col>
                            </v-row>
                        </v-container>
                        <p style="font-weight: 600;">
                            <LanguagePlaceholder default-text="Or" />
                        </p>
                        <br>
                        <p style="font-weight: 600;">
                            <LanguagePlaceholder default-text="STORAGE+" />
                        </p>
                        <p>
                            <LanguagePlaceholder default-text="Storage B2B Smart Selection Offers" />
                        </p>
                        <v-container>
                            <v-row no-gutters class="my-2">
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="0 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="2 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="4 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="8 Units" />
                                </v-col>
                                <v-col class="text-center">
                                    <LanguagePlaceholder default-text="12 Units" />
                                </v-col>
                            </v-row>
                            <v-row no-gutters
                                style="height: 50px; background-color: #244739; font-size: 20px; font-weight: 500;">
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1x Rewards" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.2x" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.3x" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.5x" />
                                </v-col>
                                <v-col class="text-center text-white align-self-center">
                                    <LanguagePlaceholder default-text="1.6x" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-container>

                </v-col>
                <v-col cols="0" sm="2"></v-col>

            </v-row>

        </v-container>
    </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useSystemStore } from '@/stores/system'

const systemStore = useSystemStore()


const selectedTab = ref(0)

onMounted(() => {
})

</script>

<style scoped>
.v-slide-group-item--active {
    background-color: #359f60;
}
</style>